import { frontendURL } from 'dashboard/helper/URLHelper';
import AppointmentsLayout from './AppointmentsLayout.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/appointments'),
      component: AppointmentsLayout,
      meta: {
        permissions: ['administrator', 'agent'],
      },
      children: [
        {
          path: '',
          name: 'appointments_root',
          redirect: { name: 'appointments_agenda' },
        },
        {
          path: 'agenda',
          name: 'appointments_agenda',
          component: () => import('./AppointmentsAgenda.vue'),
          meta: { permissions: ['administrator', 'agent'] },
        },
        {
          path: 'clients',
          name: 'appointments_clients',
          component: () => import('./AppointmentsClientsList.vue'),
          meta: { permissions: ['administrator', 'agent'] },
        },
        {
          path: 'professionals',
          name: 'appointments_professionals',
          component: () => import('./AppointmentsProfessionalsList.vue'),
          meta: { permissions: ['administrator', 'agent'] },
        },
        {
          path: 'services',
          name: 'appointments_services',
          component: () => import('./AppointmentsServicesList.vue'),
          meta: { permissions: ['administrator', 'agent'] },
        },
        {
          path: 'partners',
          name: 'appointments_partners',
          component: () => import('./AppointmentsPartnersList.vue'),
          meta: { permissions: ['administrator', 'agent'] },
        },
        // O relatório passou a viver com os outros relatórios, em
        // /reports/appointments. Link antigo continua funcionando.
        {
          path: 'reports',
          redirect: to => ({
            name: 'appointments_reports',
            params: to.params,
            query: to.query,
            hash: to.hash,
          }),
        },
      ],
    },
  ],
};
